import {
  ProductApprovalState,
  ProductApprovalRejectReason,
} from '@texas/api/endpoints/productApprovalsApi';
import { ReactSelectOption } from '@texas/types';
import {
  compareEnum,
  enumKey,
  getEnumNamesAndValues,
} from '@texas/utils/helpers/enumHelpers';
import { TFunction } from 'i18next';

export function getStateOption(state: ProductApprovalState): ReactSelectOption {
  const t = getEnumNamesAndValues(ProductApprovalState);
  const v = t.find((x) => compareEnum(ProductApprovalState, x.value, state))!;

  return { label: v.name, value: v.value };
}

export function getStateReasonOption(
  t: TFunction,
  reason: ProductApprovalRejectReason,
) {
  return {
    label: rejectReasonAsFriendlyName(t, reason),
    value: reason,
  };
}

export function rejectReasonAsFriendlyName(
  t: TFunction,
  reason: ProductApprovalRejectReason,
) {
  const type = enumKey(ProductApprovalRejectReason, reason);
  return t(`productApproval.rejectReason.${type}`);
}
